module.exports = {"150571001":"河西街道","150571002":"电厂街道","150571003":"新城街道","150571004":"滨河街道","150571100":"辽河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150571.json
// module id = 522
// module chunks = 0